import { Icon, IconifyIcon } from '@iconify/react';

interface Props {
    icon: IconifyIcon;
    /// Altura; a largura segue o logo. Sem size, acompanha a fonte ao redor, como os ícones do MUI.
    size?: number | string;
    /// Só para ícones de uma cor; os coloridos já trazem as cores da marca.
    color?: string;
}

/// Logo de marca ou ícone colorido, dos pacotes @iconify-icons.
export const BrandIcon = ({ icon, size = '1em', color }: Props) => (
    <Icon icon={icon} height={size} color={color} style={{ flexShrink: 0 }} />
);
